import React from 'react';

import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';

import { InvitationLink } from '../Presentation';

export const InvitationLinkContainer: React.FC = () => {
  const isManager = useAppSelector(authStore.selectors.isManagerSelector);
  return <InvitationLink isManager={isManager} />;
};
